import { api } from "..";

import { QueryProps } from "@/types/Api";
import { CreditFeature } from "@/types/CreditTier";

export interface DeleteCreditTierParams {
  id: number;
  feature: CreditFeature;
}

export const deleteCreditTier = async (
  props: QueryProps<DeleteCreditTierParams>
): Promise<void> => {
  await api.client.delete(`/credit-tiers/${props.params.id}`, {
    signal: props.signal,
    params: { feature: props.params.feature },
  });
};
